// extracted by mini-css-extract-plugin
module.exports = {"suggestionInputContainer":"r7P7_","suggestionList":"_2boeK","suggestionItem":"edYqy"};